import { ref } from 'vue';
import { oneProviderAPI } from '@/laravel/config';


const postItem = async (table, val) => {
    const res = ref(null);
    const err = ref(null);

    try {
        const requestOptions = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(val)
        };

        const response = await fetch(oneProviderAPI + `/${table}`, requestOptions);
        if (!response.ok) {
            throw new Error(`Network response was not OK: ${response.status} ${response.statusText}`);
        }
        const data = await response.json();
        res.value = data;
    } catch (error) {
        err.value = error.message;
    }

    return { res, err };
};

export default postItem;